import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBBadge , MDBTable, MDBTableBody, MDBTableHead, } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Divider   } from 'antd';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { ThunderboltFilled } from '@ant-design/icons';

export default class Modalroom2 extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   CRHR:"",
   idroom:'',
   nameroom:'',
   nameroomgroup:[],
  

}


//this.getExpert = this.getExpert.bind(this);
}


 componentDidMount() {
    

      setTimeout(() => {
      
         Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getroomshowforcheck')
        .then(res => {
       
          if (res.data.length !== 0) {
            const nameroomgroup = res.data;
            this.setState({ nameroomgroup });
          }
          
        }) 
      }, 0);
  
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }




    render() {
    
        
        return (
            <>
        <MDBBtn onClick={this.toggle} size="sm">ห้องเรียน</MDBBtn>
        <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
          <MDBModalHeader toggle={this.toggle}>ห้องเรียน</MDBModalHeader>
          <MDBModalBody>


          <MDBTable bordered small responsive>
                <MDBTableHead color="grey lighten-1">
                <tr>
                    <th  className="text-center">ลำดับ</th>
                    <th  className="text-center">ID</th>
                    <th  className="text-center">รหัสห้อง</th>
                    <th  className="text-center">ชื่อห้อง</th>
                  
                </tr>

                </MDBTableHead>
                <MDBTableBody>
                {this.state.nameroomgroup.map((nameroomgroup,index) => {
                    return   <tr>
                    <td className="text-center">{index+1}</td>
                    <td className="text-left">{nameroomgroup.id}</td>
                    <td  className="text-left">{nameroomgroup.id_room}</td>
                    <td  className="text-left">{nameroomgroup.name_room}</td>
                    </tr>


                    })}   


                    </MDBTableBody>
            </MDBTable>

          
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn color="secondary" onClick={this.toggle}>Close</MDBBtn>
            {/* <MDBBtn color="primary">Save changes</MDBBtn> */}
          </MDBModalFooter>
        </MDBModal>
      </>
          
        )
    }
}
